
import { Component, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Customer } from '../../models/customer/customer-model'
import { CustomerService } from '../../services/customer/customer.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { EnumDropDown } from '../../models/shared/enum-dropdown'

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss']
})
/** customer-list component*/
export class CustomerDetailComponent {
  public pagenumber: number = 0;
  public rowsPerPage: number = 10;
  public totalRecord: number = 0;
  public showBoundaryLinks: boolean;
  public searchKeyword: string = "";
  public isLoaded: boolean = false;
  public statusFilter: string;
  public statusCustomerFilter: string;
  public bulkChechUnCheck: any = false;
  public customerType: number;
  public bulkActionId: any;
  public customerList: Customer[];
  public customerStatuses: EnumDropDown[];
  //Filter items from grid
  filteredItems: Customer[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  /** customer-list ctor */
  constructor(private readonly customerService: CustomerService,
    private readonly utilitiesService: UtilitiesService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {

    this.pagenumber = 0;
    this.rowsOnPage = 10;
    this.rowsPerPage = 10;
    this.isLoaded = false;
    this.searchKeyword = "";
    this.statusFilter = "";
    this.showBoundaryLinks = true;
    this.rolePermissionService.GetRolePermissions("vendor").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.customerType = 1;
            this.bulkActionId = null;
            this.GetCustomerStatus();
            this.OnFilterChange();
          //  this.getcustomers(this.customerType);
           // this.GetRowsPerPageList();
            this.toastr.setRootViewContainerRef(vcr);
            this.statusFilter = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
    //customer = true
    //vendor = false

  }

  deletecustomer(id) {
    var ans = confirm("Are you sure to delete this customer ?");
    if (ans) {
      this.customerService.deleteCustomer(id).subscribe(result => {
        if (result) {
          this.toastr.success('Vendor has been deleted.', 'Success');
          setTimeout(() => {
            this.OnFilterChange();
           // this.getcustomers(this.customerType);
          }, 2000);
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Error');
        }
      });
    }
  }

  OnFilterChange() {
    this.pagenumber = 0;
    this.OnFilterChangegrid();
  }

  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.OnFilterChangegrid();
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.OnFilterChange();
    }
  }
  OnFilterChangegrid() {
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    this.customerService.GetVendorGrid(this.pagenumber, this.rowsOnPage, this.statusFilter, this.searchKeyword).subscribe(
      data => {
        this.isLoaded = true;
        this.customerList = data;
        if (this.customerList != null && this.customerList.length > 0)
          this.totalRecord = this.customerList[0].totalRecords;
        else
          this.totalRecord = 0;

      }
    )
  }
  getcustomers(customerType: number) {
    this.customerService.GetVendorsList().subscribe(
      data => { 
        this.customerList = data; 
        this.filteredItems = data; 
        if (customerType == 2) {
          this.statusCustomerFilter = "true";
          this.filteredItems = this.filteredItems.filter(c => c.isCustomer == true);
          
        }
        else {
          this.statusCustomerFilter = "false"
          this.filteredItems = this.filteredItems.filter(c => c.isCustomer == false);
        }
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  exportCustomer() {
    var data = this.customerList
    //this.customerService.exportAsExcelFile(data, "Test");
  }

  toggleStatus(id: string) { 
    this.customerService.toggleStatus(id).subscribe(
      data => {
        setTimeout(() => {
          this.OnFilterChange();
         // this.getcustomers(this.customerType);
        }, 2000);
      }
    )
  }

  BulkAction() { 
    var customerList = this.customerList.filter(s => s.isCheck == true);
    if (customerList.length <= 0) {
      this.toastr.info('Select any record to perform this option.', 'Info');
    }

    else {
      if (this.bulkActionId != null && this.bulkActionId != "null") {
        this.customerService.UpdateCustomerStatusBulk(customerList, this.bulkActionId).subscribe(
          data => {
            if (data) {
              this.toastr.success('Status has been updated.', 'Success');
              setTimeout(() => {
                this.OnFilterChange();
               // this.getcustomers(this.customerType);
                this.bulkActionId = null;
                this.bulkChechUnCheck = false;
              }, 500);
              
            }
            else {
              this.toastr.error('Error occurred. Oop!', 'Error');
            }
          })
      }
      else {
        this.toastr.info('Select any status to perform this option.', 'Info');
      }

    }
  }
  BulkCheckUnCheked() {
    if (this.bulkChechUnCheck == false) {
      this.customerList.forEach((item, index) => {
        this.customerList[index].isCheck = true;//true ? false : true;  
      });
    }
    if (this.bulkChechUnCheck == true) {
      this.customerList.forEach((item, index) => {
        this.customerList[index].isCheck = false;//true ? false : true;  
      });
    }
  }
  GetCustomerStatus() {
    this.customerService.GetCustomerStatus().subscribe(
      data => {
        this.customerStatuses = data;
        
      }
    )
  } 

  // Search the Grid
  onSearch() {
    this.filteredItems = this.customerList;
    //var searchText = (document.getElementById("txtSearchCustomer") as HTMLInputElement).value;
    
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);

    }
    if (this.statusFilter != "" && this.statusFilter != null && this.statusFilter != "null") {
      this.filteredItems = this.filteredItems.filter(s => s.customerStatusName == this.statusFilter);

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-components/customer-detail/customer-detail.component.ts